<script lang="ts">
    import {  NavLink } from "sveltestrap";
    import {themeCustomizer} from "../../Data/Layout/Themecustomizer"
    import {tablist,tabId} from "../../store"
    let setTabId:string
    const handleclick =(id:string) =>{
        tabId.update(value => value = id)
        tablist.update((value) => (value = true))
    }
    tabId.subscribe((value)=>{
        setTabId = value
    })
</script>

<div
    class="flex-column nac-pills"
    id="c-pills-tab"
    role="tablist"
    aria-orientation="vertical" 
>
    {#each themeCustomizer as customizerItem}
        <NavLink class={`${setTabId === customizerItem.id ? "active" : ""} ${customizerItem.class}`} id={customizerItem.id} > 
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <div class="settings {customizerItem.settings}" on:click={()=>handleclick(customizerItem.id)}>
                <i class="icofont {customizerItem.icon}" />
            </div>
            <span>{customizerItem.title}</span>
        </NavLink>
    {/each}
</div>
